import termsPdf from '../../documents/20220707-terms-and-conditions.pdf';

const Terms = () => {
    window.location.href = termsPdf;
};

export default Terms;
